var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4737C11.4853 11.4737 13.5 9.35293 13.5 6.73684C13.5 4.12076 11.4853 2 9 2C6.51472 2 4.5 4.12076 4.5 6.73684C4.5 9.35293 6.51472 11.4737 9 11.4737Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5263H7.5C6.17441 12.528 4.90356 13.083 3.96622 14.0697C3.02888 15.0564 2.50159 16.3941 2.5 17.7895V20.9474C2.5 21.2265 2.60536 21.4943 2.79289 21.6917C2.98043 21.8891 3.23478 22 3.5 22H14.5C14.7652 22 15.0196 21.8891 15.2071 21.6917C15.3946 21.4943 15.5 21.2265 15.5 20.9474V17.7895C15.4984 16.3941 14.9711 15.0564 14.0338 14.0697C13.0964 13.083 11.8256 12.528 10.5 12.5263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.669 9.46105C13.2084 8.66602 13.4988 7.71378 13.5 6.73684C13.4979 6.38998 13.4596 6.04441 13.386 5.70631C12.9787 6.21972 12.6998 6.83212 12.5746 7.48785C12.4494 8.14359 12.4818 8.82187 12.669 9.46105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.10526C16.021 4.10912 15.5467 4.20434 15.1 4.38632C15.5113 5.5517 15.6101 6.81373 15.3856 8.03427C15.1611 9.25481 14.6219 10.3868 13.827 11.3063C14.2755 11.568 14.6957 11.8804 15.08 12.2379C15.5325 12.425 16.0139 12.5228 16.5 12.5263C17.5609 12.5263 18.5783 12.0827 19.3284 11.2931C20.0786 10.5035 20.5 9.43249 20.5 8.31579C20.5 7.19909 20.0786 6.12812 19.3284 5.3385C18.5783 4.54887 17.5609 4.10526 16.5 4.10526Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.5789H16.223C17.0515 14.81 17.4976 16.2808 17.5 17.7895V20.9474C17.4968 21.3068 17.4345 21.6629 17.316 22H21.5C21.7652 22 22.0196 21.8891 22.2071 21.6917C22.3946 21.4943 22.5 21.2265 22.5 20.9474V18.8421C22.4984 17.4467 21.9711 16.109 21.0338 15.1223C20.0964 14.1357 18.8256 13.5806 17.5 13.5789Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b7433062d2055aa6325183f98668e08f.svg";
export { ForwardRef as ReactComponent };